import axios from '../util/axiosConfig';


export const fetchExamCodesRequestAPI = async (payload) => {
    let data = {
        ...payload,
        page: Math.max(0, (payload.page || 1) - 1),
    }
    return await axios.post(`/api/v1/master/exam-codes`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
};

/** Normalised list from POST /api/v1/master/exam-codes (supports { examCodes: [] } or legacy shapes). */
export const normalizeMasterExamCodesResponse = (data) => {
    if (!data) return [];
    if (Array.isArray(data.examCodes)) return data.examCodes;
    if (Array.isArray(data.content)) return data.content;
    if (Array.isArray(data)) return data;
    return [];
};

export const addUpdateExamCodeAPI = async (examCode) => {
    return await axios.post(`/api/v1/master/add-update-examcodes`, examCode)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const fetchExamModifiersAPI = async () => {
    return await axios.get(`/api/v1/examinations-modifiers`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}

export const updateExaminationModifier = async (examination) => {
    return await axios.post(`/api/v1/update-visit-examinations-modifier`, examination)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const submitBulkBillClaim = async (data) => {
    const payload = data.resubmit ? data : { visitId: data.visitId }
    return await axios.post("/api/v1/healthsystems/bulkbill/claim", payload)
        .then(function (response) {
            if (response.data) return { success: true, data: response.data }

            return { success: false }
        })
        .catch(function (error) {
            return { success: false, error }
        })
}

export const getPaymentReport = async (data) => {
    return await axios.post("/api/v1/healthsystems/bulkbill/payment-report", data)
        .then(function (response) {
            if (response.data) return { success: true, data: response.data }

            return { success: false }
        })
        .catch(function (error) {
            return { success: false, error }
        })
}

export const getClaimStatusReport = async (data) => {
    return await axios.post("/api/v1/healthsystems/bulkbill/claim-report", data)
        .then(function (response) {
            if (response.data) return { success: true, data: response.data }
            return { success: false }
        })
        .catch(function (error) {
            return { success: false, error }
        })
}

export const claimBenefitReport = async (visitNo) => {
  return await axios
    .post(
      "/api/v1/healthsystems/bulkbill/benefit-form",
      { visitId: visitNo },
      { responseType: "arraybuffer" }
    )
    .then(function (response) {
      if (response.data) {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const name = `Claim-advise-${visitNo}`;
        const fileName = `${name}.pdf`;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return { success: true };
      }

      return { success: false };
    })
    .catch(function (error) {
      return { success: false, error };
    });
};
  
export const submitInPatientClaimAPI = async (payload) => {
    return await axios.post("/api/v1/healthsystems/inpatient/claim", payload)
        .then(function (response) {
            if (response.data) return { success: true, data: response.data }

            return { success: false }
        })
        .catch(function (error) {
            return { success: false, error }
        })
}

export const submitPatientClaimAPI = async (payload) => {
  return await axios
    .post("/api/v1/healthsystems/patient/claim", payload)
    .then(function (response) {
      if (response.data) return { success: true, data: response.data };

      return { success: false };
    })
    .catch(function (error) {
      return { success: false, error };
    });
};

export const deleteRejectedInvoices = async (visitNo) => {
  return await axios
    .delete(`/api/v1/medicare-invoices/rejected/${visitNo}`)
    .then(function (response) {
      if (response.data) return { success: true, data: response.data };
      return { success: false };
    })
    .catch(function (error) {
      return { success: false, error };
    });
};